import { render } from "./Trainee_Allowance_Summary.vue?vue&type=template&id=1b46c9fa&ts=true"
import script from "./Trainee_Allowance_Summary.vue?vue&type=script&lang=ts"
export * from "./Trainee_Allowance_Summary.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__